import { defineMessages } from 'react-intl';

export const unitMessages = defineMessages({
  poundsShort: {
    defaultMessage: 'lb',
    id: 'OSetWJ',
    description: 'Abbreviation for pounds weight unit',
  },
  pounds: {
    defaultMessage: 'lbs',
    id: 'T3P7e4',
    description: 'Abbreviation for pounds weight unit (used in summaries)',
  },
  ounces: {
    defaultMessage: 'oz',
    id: 'lzIxxt',
    description: 'Abbreviation for ounces weight unit',
  },
  kilograms: {
    defaultMessage: 'kg',
    id: 'dTx8ZR',
    description: 'Abbreviation for kilograms weight unit',
  },
  grams: {
    defaultMessage: 'g',
    id: 'FLJP3O',
    description: 'Abbreviation for grams weight unit',
  },
  inches: {
    defaultMessage: 'in',
    id: 'soIGhD',
    description: 'Abbreviation for inches dimension unit',
  },
  centimeters: {
    defaultMessage: 'cm',
    id: 'BROKpc',
    description: 'Abbreviation for centimeters dimension unit',
  },
});
